import { createI18n } from 'vue-i18n';
import tr from '../locales/tr.json';
import en from '../locales/en.json';

const DEFAULT_LOCALE = 'en';
const FALLBACK_LOCALE = 'en';

const i18n = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages: { tr, en },
  missingWarn: false,
  fallbackWarn: false,
});

export default i18n;

export const setDocumentLang = (locale) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
  }
};

export const syncI18nLocale = (locale) => {
  const resolved = locale === 'tr' ? 'tr' : 'en';
  i18n.global.locale.value = resolved;
  setDocumentLang(resolved);
  return resolved;
};
